import template from './sw-cms-el-config-sidebar-filter.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
